export default __webpack_public_path__ + "a5f47afbd61ab166bd3b72a63d7692a1.png";